import { Text } from '../../../../../Text/Text';
import { STATE_BASE_COLOR } from '../../constants/constants';
import { LegendGradient } from '../LegendGradient/LegendGradient';

export const MapLegend = () => {
  return (
    <div className="flex flex-row items-end justify-center gap-2 px-4 sm:px-0">
      <Text variant="sm" as="div" className="text-abyss constantSize mb-0 font-semibold">
        Low
      </Text>
      <LegendGradient color={STATE_BASE_COLOR} />
      <Text variant="sm" as="div" className="text-abyss constantSize mb-0 font-semibold">
        High
      </Text>
    </div>
  );
};
